"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VISIT_SAVED_TRAVELERS = exports.VISIT_REFER_FRIEND = exports.VISIT_PRIVACY_SECURITY = exports.VISIT_PRICE_ALERTS = exports.VISIT_PAYMENT_METHODS = exports.VISIT_MY_TRIPS = exports.VISIT_KIWICOM_CREDITS = exports.VISIT_INBOX = exports.VISIT_FARE_LOCKS = exports.VISIT_BILLING_ADDRESSES = exports.SUBSCRIPTION_MODAL_OPENED = exports.REGIONAL_SETTINGS_MODAL_OPENED = exports.OPEN_SIDE_NAV = exports.HELP_BUTTON_CLICKED = exports.CLOSE_SIDE_NAV = exports.CLOSE_MODAL = exports.CLICK_ON_SIGN_OUT = exports.CLICK_ON_PREFERENCES = void 0;
const OPEN_SIDE_NAV = exports.OPEN_SIDE_NAV = {
  action: "open side bar navigation",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
const CLOSE_SIDE_NAV = exports.CLOSE_SIDE_NAV = {
  action: "close side bar navigation",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
const VISIT_MY_TRIPS = exports.VISIT_MY_TRIPS = {
  action: "visit my trips from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
const VISIT_FARE_LOCKS = exports.VISIT_FARE_LOCKS = {
  action: "visit fare locks from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
const VISIT_PRICE_ALERTS = exports.VISIT_PRICE_ALERTS = {
  action: "visit price alerts from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
const VISIT_KIWICOM_CREDITS = exports.VISIT_KIWICOM_CREDITS = {
  action: "visit kiwicom credits from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
const CLICK_ON_PREFERENCES = exports.CLICK_ON_PREFERENCES = {
  action: "click on preferences from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
const VISIT_REFER_FRIEND = exports.VISIT_REFER_FRIEND = {
  action: "visit refer a friend from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
const VISIT_INBOX = exports.VISIT_INBOX = {
  action: "visit inbox from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
const VISIT_SAVED_TRAVELERS = exports.VISIT_SAVED_TRAVELERS = {
  action: "visit saved travelers from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true,
    logmole: true
  }
};
const VISIT_PRIVACY_SECURITY = exports.VISIT_PRIVACY_SECURITY = {
  action: "visit privacy & security from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true,
    logmole: true
  }
};
const VISIT_PAYMENT_METHODS = exports.VISIT_PAYMENT_METHODS = {
  action: "visit payment methods from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true,
    logmole: true
  }
};
const VISIT_BILLING_ADDRESSES = exports.VISIT_BILLING_ADDRESSES = {
  action: "visit billing addresses from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
const HELP_BUTTON_CLICKED = exports.HELP_BUTTON_CLICKED = {
  action: "help button clicked",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
const CLICK_ON_SIGN_OUT = exports.CLICK_ON_SIGN_OUT = {
  action: "click on sign out from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true,
    logmole: true
  }
};
const SUBSCRIPTION_MODAL_OPENED = exports.SUBSCRIPTION_MODAL_OPENED = {
  action: "open subscription modal",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true,
    logmole: true
  }
};
const REGIONAL_SETTINGS_MODAL_OPENED = exports.REGIONAL_SETTINGS_MODAL_OPENED = {
  action: "open regional settings modal",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true,
    logmole: true
  }
};
const CLOSE_MODAL = exports.CLOSE_MODAL = {
  action: "close modal",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true,
    logmole: true
  }
};